export default __webpack_public_path__ + "static/media/Notify.e7547c88.svg";